// Return types can be passed to restrictToLoggedIn to specify
// SISU's behavior when given a returnTo
export var LoggedOutReturnType;
(function(LoggedOutReturnType) {
    // returnTo only applies for new joins, logins ignore returnTo
    LoggedOutReturnType["JOIN_ONLY"] = "join_only";
})(LoggedOutReturnType || (LoggedOutReturnType = {}));

//# sourceMappingURL=types.js.map